import { Link } from "react-router-dom";
import {
  EMAIL,
  SiteFooter,
  SiteNav,
  usePageMeta,
  useSiteStyles,
} from "./SiteLayout";

const MAILTO = `mailto:${EMAIL}?subject=${encodeURIComponent("Exclusão de dados")}`;

export default function ExclusaoDeDados() {
  useSiteStyles();
  usePageMeta(
    "Exclusão de Dados | Solfac",
    "Saiba como solicitar a exclusão dos dados acessados pelo aplicativo Solfac Social, da Solution Factory, e como remover o acesso do app no Instagram e no Facebook.",
  );

  return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      <SiteNav />

      <main className="sf-legal">
        <div className="sf-section-tag">Documento legal</div>
        <h1 className="sf-section-title">
          EXCLUSÃO DE <span>DADOS</span>
        </h1>
        <p className="sf-legal-updated">
          Última atualização: 22 de outubro de 2026
        </p>

        <p>
          Esta página explica como solicitar a exclusão dos dados acessados pelo
          aplicativo <strong>Solfac Social</strong>, da Solution Factory, a
          partir da sua conta do Instagram ou do Facebook.
        </p>

        <h2>Como solicitar a exclusão</h2>
        <ol>
          <li>
            Envie um e-mail para <a href={MAILTO}>{EMAIL}</a> com o assunto{" "}
            <strong>"Exclusão de dados"</strong>.
          </li>
          <li>
            No corpo da mensagem, informe o <strong>nome de usuário do
            Instagram</strong> e o <strong>nome da empresa</strong> vinculados à
            conta.
          </li>
          <li>
            Aguarde nossa resposta. Confirmaremos o recebimento e, depois, a
            conclusão da exclusão pelo mesmo e-mail.
          </li>
        </ol>

        <h2>Prazo de atendimento</h2>
        <p>
          A solicitação é atendida em até <strong>15 dias úteis</strong> a
          partir do recebimento do e-mail. Ao final, você recebe uma
          confirmação por e-mail.
        </p>

        <h2>O que é apagado</h2>
        <p>Excluímos todos os dados armazenados vinculados à conta, incluindo:</p>
        <ul>
          <li>Tokens de acesso;</li>
          <li>Dados de perfil;</li>
          <li>Métricas e insights de desempenho;</li>
          <li>Conteúdos armazenados.</li>
        </ul>

        <h2>Remover o aplicativo por conta própria</h2>
        <p>
          Você também pode remover o acesso do Solfac Social diretamente nas
          configurações das plataformas:
        </p>
        <ul>
          <li>
            <strong>Instagram:</strong> Configurações &gt; Apps e sites.
            Selecione o Solfac Social e remova o acesso.
          </li>
          <li>
            <strong>Facebook:</strong> Configurações &gt; Integrações
            empresariais. Selecione o Solfac Social e remova o acesso.
          </li>
        </ul>
        <p>
          A remoção impede que o aplicativo acesse novos dados. Para apagar os
          dados que já estão armazenados conosco, envie também a solicitação de
          exclusão por e-mail, conforme as instruções acima.
        </p>

        <h2>Dúvidas</h2>
        <p>
          Para saber mais sobre como tratamos seus dados, consulte a nossa{" "}
          <Link to="/privacidade">Política de Privacidade</Link> ou escreva
          para <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
        </p>
      </main>

      <SiteFooter />
    </div>
  );
}
